import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfigDialog(props) {
  const classes = useStyles();
  const open = props.open;
  const user = props.user;
  const updateConfig = props.updateConfig;
  const handleClose = props.handleClose;

  const [configVanityUrlOpen, setConfigVanityUrlOpen] = React.useState(false);

  const handleClickConfigVanityUrlOpen = () => {
    setConfigVanityUrlOpen(true);
  };

  const handleConfigVanityUrlClose = () => {
    setConfigVanityUrlOpen(false);
  };

  return (
    <div>
      {user && (
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Configuración
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
            <ListItem button>
              <ListItemText
                primary="Vanity URL"
                secondary={user.vanity_url}
                onClick={handleClickConfigVanityUrlOpen}
              />
              <a href={"/" + user.vanity_url}>Test</a>
              <FormDialog
                handleClose={handleConfigVanityUrlClose}
                open={configVanityUrlOpen}
                title="Tu URL vanidoso"
                text="Acá se van a poder ver tus favoritos"
                inputLabel="Solo letras y numeros, nada de espacios"
                inputType="text"
                inputId="vanity_url"
                inputValue={user.vanity_url}
                inputValidationRE="[a-z0-9]"
                updateConfig={updateConfig}
              />
            </ListItem>
            <Divider />
          </List>
        </Dialog>
      )}
    </div>
  );
}
function FormDialog({
  handleClose,
  open,
  title,
  text,
  inputValidationRE,
  inputLabel,
  inputType,
  inputValue,
  inputId,
  updateConfig
}) {
  const [value, setValue] = React.useState();
  if (value === undefined) {
    setValue(inputValue);
  }
  const handleSave = () => {
    const newConfig = {};
    newConfig[inputId] = value;
    updateConfig(newConfig);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id={inputId}
          label={inputLabel}
          type={inputType}
          defaultValue={inputValue}
          inputProps={inputValidationRE && { pattern: inputValidationRE }}
          onChange={e => {
            setValue(e.target.value);
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
